<template>
  <el-dialog v-model="visible" append-to-body class="choose-space-dia" :show-close="false"
    :width="isNoList ? '629px' : '992px'" :style="{ '--el-dialog-padding-primary': 0 }">
    <div class="choose-space">
      <div class="choose-space-close">
        <i class="iconfont icon-shanchu3" @click="visible = false"></i>
      </div>
      <div class="no-list" v-if="isNoList">
        <img class="no-list-img" src="@/assets/no-space.png">
        <h1 class="no-list-title">您的【学校（标签）】空间门户未开启</h1>
        <span class="no-list-explain">请联系【学校（标签）】管理员</span>
        <!-- <div class="no-list-btn">进入管理</div> -->
      </div>
      <div class="choose-space-content" v-else>
        <div class="choose-space-content-title">请选择你想要进入的空间</div>
        <div class="choose-space-content-search">
          <el-input @input="inpChange" @keydown.enter="goSearch" placeholder="请输入空间类型或者名称" v-model="searchText">
            <template v-slot:prefix>
              <i class="iconfont icon-sousuo"></i>
            </template>
          </el-input>
        </div>
        <el-scrollbar style="height: 540px;">
          <div class="choose-space-content-list" :class="searchList.length < 4 ? 'con-center' : ''">
            <spaceComp @click="goSpace(item)" class="square-2" :info="item" v-for="item in searchListComp" :key="item.organizationId"></spaceComp>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import spaceComp from '@/components/schoolInstrument/component/space/indexComp.vue'
import { cloneDeep } from 'lodash'
export default {
  // 组件名称
  name: 'chooseSpace',
  // 组件参数 接收来自父组件的数据
  props: {
    isView: {
      type: Boolean,
      default: false
    },
    spaceList: {
      type: Array,
      default: () => ([])
    },
    // 是否是组件引用
    isCopm: {
      type: Boolean,
      default: false
    }
  },
  // 局部注册的组件
  components: {
    spaceComp
  },
  // 组件状态值
  data() {
    return {
      visible: false,
      searchText: '',
      list: [],
      searchList: []
    }
  },
  // 侦听器
  watch: {
    isView: {
      handler(val) {
        if (val) {
          this.searchList = JSON.parse(JSON.stringify(this.spaceList))
          this.list = JSON.parse(JSON.stringify(this.spaceList))
          this.visible = true
        }
      }
    },
    visible: {
      handler(val) {
        if (!val) {
          this.$emit('update:isView', false)
        }
      }
    }
  },
  // 组件方法
  methods: {
    inpChange() {
      if (this.searchText === '') {
        this.searchList = this.list
      }
    },
    goSpace(item) {
      if (this.isCopm) {
        this.$emit('goSpace', {
          name: item.name,
          spaceId: item.organizationId
        })
      } else {
        localStorage.setItem('spaceid', item.organizationId)
        this.$openAdmin({ path: '/cust/main/spaceMain/home' }, { isNewTab: true })
      }
    },
    goSearch() {
      this.searchList = this.list.filter(item => item.name.indexOf(this.searchText) !== -1)
    },
  },
  computed: {
    searchListComp() {
      const opt = cloneDeep(this.searchList).sort((prev, next) => {
        if (prev.activationtotalnum === undefined) {
          prev.activationtotalnum = 0
        }
        if (next.activationtotalnum === undefined) {
          next.activationtotalnum = 0
        }
        return next.activationtotalnum - prev.activationtotalnum
      })
      return opt
    },
    isNoList() {
      return this.list.length === 0
    }
  }
}
</script>

<style scoped lang="scss">
.choose-space {
  position: relative;

  .choose-space-close {
    position: absolute;
    top: 16px;
    right: 25px;

    .icon-shanchu3 {
      color: #D8D8D8;
      font-size: 18px;
      cursor: pointer;

      &:hover {
        color: #4e86ff;
      }
    }
  }

  &-content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 20px 0;

    &-title {
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      margin-bottom: 12px;
      padding: 0 32px;
    }

    &-search {
      margin-bottom: 10px;
      padding: 0 32px;

      ::v-deep .el-input {
        .el-input__wrapper {
          border-radius: 23px;
          border: 1px solid #E6EAEE;
          padding-left: 52px;
        }

        .el-input__prefix {
          left: 0;
          width: 52px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .icon-sousuo {
            font-size: 17px;
            color: #4e86ff;
          }
        }
      }
    }

    .con-center {
      justify-content: center;
    }

    &-list {
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      padding: 0 32px 2px 32px;
      box-sizing: border-box;

      .square-2 {
        cursor: pointer;
        margin-top: 20px;
        margin-right: 20px;

        &:nth-of-type(4n) {
          margin-right: 0;
        }
      }
    }
  }

  .no-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &-img {
      width: 353px;
      height: 206px;
      margin-top: 38px;
    }

    &-title {
      width: 340px;
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      margin-bottom: 12px;
    }

    &-explain {
      width: 224px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 22px;
      margin-bottom: 34px;
    }

    &-btn {
      width: 200px;
      height: 54px;
      background: #B10419;
      border-radius: 27px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 66px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
}
</style>

<style lang="scss">
.choose-space-dia {
  border-radius: 16px;

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__header {
    height: initial !important;
    padding: 0 !important;
    border: none !important;
  }
}
</style>